<!-- Main Container -->
<div class="w-full max-w-full">
  <!-- Controls Section -->
  <div class="mb-3 w-full">
    <div class="flex items-center justify-between gap-2 flex-wrap">
      <!-- View mode buttons -->
      <div class="flex items-center gap-2">
        <!-- Filtro rápido de responsable -->
        <div class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
          <button
            type="button"
            (click)="setOwnerFilter('all')"
            class="px-3 py-1.5 text-sm font-medium transition-colors"
            [ngClass]="filtroOwner === 'all'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
            Todos
          </button>
          <button
            type="button"
            (click)="setOwnerFilter('mine')"
            class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
            [ngClass]="filtroOwner === 'mine'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
            Mis leads
          </button>
        </div>

        <button
          type="button"
          (click)="changeViewMode('leadCycle')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
          [ngClass]="viewMode === 'leadCycle'
            ? 'bg-brand-500 text-white'
            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'">
          Ciclo
        </button>
        <button
          type="button"
          (click)="changeViewMode('leadState')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
          [ngClass]="viewMode === 'leadState'
            ? 'bg-brand-500 text-white'
            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'">
          Tipos de lead
        </button>
      </div>

      <!-- Action buttons -->
      <div class="flex items-center gap-1.5">
        <button
          type="button"
          (click)="toggleFilters()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
          </svg>
          {{ showFilters ? 'Ocultar' : 'Filtros' }}
        </button>
        <button
          type="button"
          (click)="vistaLista()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"></path>
          </svg>
          Lista
        </button>
        <button
          type="button"
          (click)="nuevoLead()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
          </svg>
          Nuevo
        </button>
      </div>
    </div>
  </div>

  <!-- Filters Panel -->
  @if (showFilters) {
  <div class="mb-3 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3 w-full">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
      <!-- Búsqueda por nombre -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Buscar por nombre
        </label>
        <input
          type="text"
          [(ngModel)]="filters.searchName"
          (ngModelChange)="applyFilters()"
          placeholder="Nombre del lead..."
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      </div>

      <!-- Filtro Estado (solo si no es el modo actual) -->
      @if (availableFilterFields.leadState) {
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Tipo
        </label>
        <select
          [(ngModel)]="filters.idLeadState"
          (ngModelChange)="applyFilters()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (state of leadStates; track state.id) {
          <option [ngValue]="state.id">{{ state.name }}</option>
          }
        </select>
      </div>
      }

      <!-- Filtro Ciclo (solo si no es el modo actual) -->
      @if (availableFilterFields.leadCycle) {
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Ciclo
        </label>
        <select
          [(ngModel)]="filters.idLeadCycle"
          (ngModelChange)="applyFilters()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (cycle of leadCycles; track cycle.id) {
          <option [ngValue]="cycle.id">{{ cycle.name }}</option>
          }
        </select>
      </div>
      }

      <!-- Filtro Descalificados -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Descalificados
        </label>
        <select
          [(ngModel)]="filters.isDisqualified"
          (ngModelChange)="applyFilters()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          <option [ngValue]="false">Activos</option>
          <option [ngValue]="true">Descalificados</option>
        </select>
      </div>

      <!-- Filtro País (por prefijo telefónico del contacto) -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          País
        </label>
        <app-country-select
          [countries]="filterCountries"
          [value]="filtroPais"
          [clearable]="true"
          placeholder="Todos"
          (valueChange)="onCountryFilterChange($event)" />
      </div>

      <!-- Botón Limpiar -->
      <div class="flex items-end">
        <button
          type="button"
          (click)="clearFilters()"
          class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
          Limpiar Filtros
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Loading State -->
  @if (loading) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
  </div>
  }

  <!-- Error State -->
  @if (error) {
  <div class="bg-error-50 dark:bg-error-900/20 border border-error-200 dark:border-error-800 text-error-700 dark:text-error-400 px-4 py-3 rounded mb-6">
    {{ error }}
  </div>
  }

  <!-- Kanban Board -->
  @if (!loading && !error) {
  <div class="kanban-container overflow-x-auto w-full">
    <div class="flex gap-4 pb-4" style="min-width: fit-content;">
      @for (column of columns; track column.id) {
      <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 min-w-72 w-72 flex-shrink-0">
        <!-- Column Header -->
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 rounded-full {{ column.color }}"></div>
            <h3 class="font-semibold text-gray-900 dark:text-white text-sm">{{ column.name }}</h3>
          </div>
          <span class="text-xs font-medium text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-700 px-2 py-1 rounded">
            {{ column.leads.length }}
          </span>
        </div>

        <!-- Drop List -->
        <div
          cdkDropList
          [id]="'lead-col-' + column.id"
          [cdkDropListData]="column.leads"
          [cdkDropListConnectedTo]="getColumnIds()"
          (cdkDropListDropped)="drop($event, column)"
          class="min-h-125 max-h-175 overflow-y-auto space-y-3">

          @for (lead of column.leads; track lead.id) {
          <div
            cdkDrag
            (click)="verDetalle(lead, $event)"
            class="bg-white dark:bg-gray-900 rounded-lg p-4 shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-shadow relative group cursor-pointer"
            [class.opacity-60]="lead.isDisqualified">

            <!-- Action buttons -->
            <div class="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
              <button type="button"
                (click)="editarLead(lead, $event); $event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                [disabled]="lead.isDisqualified"
                [class.opacity-50]="lead.isDisqualified"
                [class.cursor-not-allowed]="lead.isDisqualified"
                class="p-1.5 bg-brand-500 hover:bg-brand-600 text-white rounded transition-colors cursor-pointer"
                title="Editar">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                  </path>
                </svg>
              </button>
              @if (lead.isDisqualified) {
              <button type="button"
                [appDisableWithoutPermission]="'leads:edit'"
                (click)="reabrirLead(lead, column, $event); $event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                class="p-1.5 bg-success-500 hover:bg-success-600 text-white rounded transition-colors cursor-pointer"
                title="Reabrir lead">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
                  </path>
                </svg>
              </button>
              }
              <button type="button"
                (click)="eliminarLead(lead, column, $event); $event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
                [disabled]="lead.isDisqualified"
                [class.opacity-50]="lead.isDisqualified"
                [class.cursor-not-allowed]="lead.isDisqualified"
                class="p-1.5 bg-error-500 hover:bg-error-600 text-white rounded transition-colors cursor-pointer"
                title="Eliminar">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                  </path>
                </svg>
              </button>
            </div>

            <!-- Lead Name -->
            <h4 class="font-medium text-gray-900 dark:text-white mb-2 pr-20 flex items-center gap-2">
              @if (countryFlagCode(lead.contactPhone); as cc) {
                <span class="fi fi-{{ cc }} rounded-sm shrink-0" [title]="countryName(lead.contactPhone)"></span>
              }
              <span class="truncate">{{ lead.name }}</span>
            </h4>

            <!-- Badges según el modo de vista -->
            <div class="flex flex-wrap gap-2 mt-2">
              @if (viewMode !== 'leadState' && lead.idLeadState) {
              <app-badge color="info" size="sm">{{ lead._stateName }}</app-badge>
              }
              @if (viewMode !== 'leadCycle' && lead.idLeadCycle) {
              <app-badge color="success" size="sm">{{ lead._cycleName }}</app-badge>
              }
              @if (lead.isDisqualified) {
              <app-badge color="error" size="sm">Descalificado</app-badge>
              }
            </div>

            <!-- Retry scheduled indicator -->
            @if (lead.isRetryScheduled && lead.retryDate) {
            <div class="flex items-center gap-1.5 mt-2 text-xs text-warning-600 dark:text-warning-400">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <span>{{ lead.retryDate | date:'dd/MM/yyyy' }}</span>
            </div>
            }

            <!-- Metadatos enriquecidos (Inc 30) -->
            <div class="mt-2.5 space-y-1.5">
              <!-- Prioridad -->
              @if (lead.priority) {
              <div class="flex items-center gap-1.5">
                <span class="text-[10px] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">Prioridad</span>
                <app-badge [color]="priorityColor(lead.priority)" size="sm">{{ priorityLabel(lead.priority) }}</app-badge>
              </div>
              }
              <!-- Tarea pendiente -->
              @if (lead.nextTaskTitle) {
              <div class="flex items-start gap-1.5 text-xs text-gray-600 dark:text-gray-300">
                <svg class="w-3.5 h-3.5 flex-shrink-0 mt-0.5 text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
                </svg>
                <span class="truncate">
                  {{ lead.nextTaskTitle }}
                  @if (lead.nextTaskDueDate) {
                  <span class="text-gray-400 dark:text-gray-500">· {{ lead.nextTaskDueDate | date:'dd/MM' }}</span>
                  }
                </span>
              </div>
              }
              <!-- Última actividad -->
              @if (lead.lastActivityAt) {
              <div class="flex items-center gap-1.5 text-[11px] text-gray-400 dark:text-gray-500">
                <svg class="w-3 h-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <span>Últ. actividad: {{ lead.lastActivityAt | date:'dd/MM/yyyy' }}</span>
              </div>
              }
            </div>

            <!-- Drag handle -->
            <div class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-800 flex justify-center">
              <div class="w-8 h-1 bg-gray-300 dark:bg-gray-600 rounded"></div>
            </div>
          </div>
          }

          <!-- Empty state -->
          @if (column.leads.length === 0 && !loading) {
          <div class="flex flex-col items-center justify-center py-12 text-gray-400 dark:text-gray-600">
            <svg class="w-12 h-12 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2">
              </path>
            </svg>
            <p class="text-sm">No hay leads</p>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>

  <!-- Paginación global -->
  @if (globalTotalPages >= 1) {
  <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4">
    <div class="flex items-center justify-between gap-4 flex-wrap">
      <div class="flex items-center gap-2">
        <span class="text-sm text-gray-500 dark:text-gray-400">
          {{ globalTotalElements }} registros
        </span>
        <select
          [ngModel]="pageSize"
          (ngModelChange)="changePageSize($event)"
          class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          @for (opt of PAGE_SIZE_OPTIONS; track opt) {
            <option [value]="opt">{{ opt }}</option>
          }
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button"
          (click)="cambiarPagina(globalPage - 1)"
          [disabled]="!hasPrevPage"
          class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          Anterior
        </button>
        <div class="flex items-center gap-1.5">
          <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
          <select
            [ngModel]="pageDisplay"
            (ngModelChange)="cambiarPagina($event - 1)"
            class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            @for (p of pagesArray; track p) {
              <option [value]="p">{{ p }}</option>
            }
          </select>
          <span class="text-sm text-gray-500 dark:text-gray-400">de {{ globalTotalPages }}</span>
        </div>
        <button type="button"
          (click)="cambiarPagina(globalPage + 1)"
          [disabled]="!hasNextPage"
          class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
          Siguiente
        </button>
      </div>
    </div>
  </div>
  }
  }
</div>

<!-- Close Lead Modal -->
<app-lead-close-modal
  [isOpen]="showCloseLeadModal"
  [lead]="closeLeadLead"
  [disqualificationReasons]="disqualificationReasons"
  [saving]="savingCloseLead"
  (confirmed)="confirmarCerrarLead($event)"
  (cancelled)="cancelarCerrarLead()">
</app-lead-close-modal>

<!-- Detail Modal -->
<app-lead-detail-modal
  [isOpen]="showDetailModal"
  [lead]="selectedLead"
  [leadStates]="leadStates"
  [leadCycles]="leadCycles"
  [disqualificationReasons]="disqualificationReasons"
  (close)="cerrarDetalle()">
</app-lead-detail-modal>

<!-- El drawer de negocio (trigger CREATE_DEAL) NO se monta aquí: AppLayout ya monta
     <app-deal-form-drawer /> globalmente y DealDrawerService es providedIn:'root'.
     Montarlo otra vez creaba una segunda instancia suscrita al mismo state$: dos
     formularios y dos overlays superpuestos, con carga duplicada de catálogos. -->
